import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Necesito experiencia?',
  a: 'No, está pensado para empezar desde cero.'
}, {
  q: '¿Necesito cocina profesional?',
  a: 'No. Podés hacerlo desde tu casa.'
}, {
  q: '¿Cuánto tengo que invertir?',
  a: 'Muy poco. Usás lo que ya tenés.'
}, {
  q: '¿Funciona en cualquier ciudad?',
  a: 'Sí, es adaptable a cualquier lugar.'
}, {
  q: '¿Cuándo puedo empezar a vender?',
  a: 'En pocos días si aplicás el sistema.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 md:py-28 bg-white" data-id="element-30">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="text-center mb-12" data-id="element-32">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-33">
            <span className="text-olive" data-id="element-34">Preguntas</span>{' '}
            <span className="text-brown-dark" data-id="element-35">Frecuentes</span>
          </h2>
        </div>

        <div className="space-y-4" data-id="element-36">
          {faqs.map((faq, index) => <div key={index} className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${openIndex === index ? 'border-gold bg-beige/30' : 'border-beige-dark bg-white'}`} data-id="element-37">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-38">
                <span className="font-bold text-brown-dark text-lg" data-id="element-39">
                  {faq.q}
                </span>
                <span className={`ml-4 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180 text-gold' : 'text-brown'}`} data-id="element-40">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-41">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-42"></path>
                  </svg>
                </span>
              </button>

              <AnimatePresence data-id="element-43">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-44">
                    <div className="px-6 pb-5 pt-0 text-brown text-lg" data-id="element-45">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}